var app = angular.module('app-cart', ['app-cart-service']);


app.controller('Cart', ['$scope', '$http', '$window', '$sce', 'cartService', function ($scope, $http, $window, $sce, cartService) {
    $scope.Cart = {};
    $scope.isCartSummaryOpen = false;
    $scope.inProgress = false;
    $scope.culture = $window.culture;

    $scope.getCartSummary = function (fromCache) {
        if (fromCache) {
            $scope.Cart = cartService._cartSummary;
        } else {
            cartService.getCartSummary().then(function () {
                $scope.Cart = cartService._cartSummary;
            })
        }
    }

    $scope.updateCartItem = function (item, quantity) {
        if ($scope.inProgress == false) {
            $scope.inProgress = true;
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/updatecartitem' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '')
                $http({
                    method: 'POST',
                    url: url,
                    cache: false,
                    withCredentials: true,
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    data: { partnumberCode: item.Product.Partnumber.Code, modelId: item.Product.Id, productType: item.Product.ProductTypeId, quantity: quantity, SupplementaryItemPartnumberCode: (item.SupplementaryItemPartnumberCode != null ? item.SupplementaryItemPartnumberCode : '') },
                }).then(function (res) {
                    $scope.Cart = res.data;

                    //GA4
                    var items = [];
                    items.push({
                        //'item_id': item.Product.ProductTypeId == 3 ? 'giftcard-' + item.Product.PriceOriginal : (item.Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + item.Product.GA_ProductId.toString(),
                        'item_id': (item.Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + item.Product.GA_ProductId.toString(),
                        'item_name': item.Product.Name.toLowerCase(),
                        'discount': item.Product.PriceOriginal > 0 && item.Product.Partnumber._price != null ? item.Product.PriceOriginal - item.Product.Partnumber._price : 0,
                        'index': 1,
                        'item_brand': item.Product.BrandName.toLowerCase(),
                        'item_category': item.Product.PageCategories != undefined && item.Product.PageCategories.length > 0 ? item.Product.PageCategories[0].GA_label.toLowerCase() : 'n/a',
                        'item_category2': item.Product.PageCategories != undefined && item.Product.PageCategories.length > 1 ? item.Product.PageCategories[1].GA_label.toLowerCase() : 'n/a',
                        'item_category3': item.Product.PageCategories != undefined && item.Product.PageCategories.length > 2 ? item.Product.PageCategories[2].GA_label.toLowerCase() : 'n/a',
                        /*'item_list_id': '$item_list_id',*/
                        /*'item_list_name': $scope.modelcategory,*/
                        'item_variant': (item.Product.Partnumber.Size + (item.Product.Partnumber.Color != undefined && item.Product.Partnumber.Color.length > 0 ? ' ' + item.Product.Partnumber.Color : '')).toLowerCase(),
                        'price': item.Product.PriceOriginal,
                        'quantity': 1
                    });
                    trackEventGlobalAndLocalGA4({
                        'ga4_name': quantity == -1 ? 'remove_from_cart' : 'add_to_cart',
                        'ga4_currency': window.currencyCode,
                        'ga4_value': item.Product.Partnumber._price,
                        'ga4_items': items
                    });

                    //set focus A360
                    setTimeout(function () {
                        if (quantity == 1) {
                            $('#cartItem-' + item.Product.Partnumber.Code).find('#increaseCartItem').focus();
                        } else {
                            $('#cartItem-' + item.Product.Partnumber.Code).find('#decreaseCartItem').focus();
                        }
                    }, 100);

                    $scope.inProgress = false;
                });
            });
        }
    }

    $scope.removeCartItem = function (item) {
        if ($scope.inProgress == false) {
            $scope.inProgress = true;
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/removecartitem/' + item.Id + '/json?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '') + (item.SupplementaryItemPartnumberCode != null ? '&SupplementaryItemPartnumberCode=' + item.SupplementaryItemPartnumberCode : '');
                $http({
                    method: 'GET',
                    url: url,
                    cache: false,
                    withCredentials: true
                }).then(function (res) {
                    $scope.Cart = res.data;

                    //GA4
                    var items = [];
                    items.push({
                        //'item_id': item.Product.ProductTypeId == 3 ? 'giftcard-' + item.Product.PriceOriginal : (item.Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + item.Product.GA_ProductId.toString(),
                        'item_id': (item.Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + item.Product.GA_ProductId.toString(),
                        'item_name': item.Product.Name.toLowerCase(),
                        'discount': item.Product.PriceOriginal > 0 && item.Product.Partnumber != null && item.Product.Partnumber._price != null ? item.Product.PriceOriginal - item.Product.Partnumber._price : 0,
                        'index': 1,
                        'item_brand': (item.Product.BrandName != undefined ? item.Product.BrandName : window.divisionFullName).toLowerCase(),
                        'item_category': item.Product.PageCategories != undefined && item.Product.PageCategories.length > 0 ? item.Product.PageCategories[0].GA_label.toLowerCase() : 'n/a',
                        'item_category2': item.Product.PageCategories != undefined && item.Product.PageCategories.length > 1 ? item.Product.PageCategories[1].GA_label.toLowerCase() : 'n/a',
                        'item_category3': item.Product.PageCategories != undefined && item.Product.PageCategories.length > 2 ? item.Product.PageCategories[2].GA_label.toLowerCase() : 'n/a',
                        /*'item_list_name': item.Product.GA_Category,*/
                        'item_variant': item.Product.Partnumber != null ? (item.Product.Partnumber.Size + (item.Product.Partnumber.Color != undefined && item.Product.Partnumber.Color.length > 0 ? ' ' + item.Product.Partnumber.Color : '')).toLowerCase() : '',
                        'price': item.Product.PriceOriginal,
                        'quantity': 1
                    });
                    trackEventGlobalAndLocalGA4({
                        'ga4_name': 'remove_from_cart',
                        'ga4_currency': window.currencyCode,
                        'ga4_value': item.Product.Partnumber != null && item.Product.Partnumber.price != null ? item.Product.Partnumber.price : item.Product.PriceOriginal,
                        'ga4_items': items
                    });

                    $scope.inProgress = false;

                    //reload page
                    setTimeout(function () {
                        if (location.pathname.indexOf('shop/review') > -1) {
                            location.reload();
                        }
                    }, 2000);
                });
            });
        }
    }

    $scope.showCartSummary = function () {
        $scope.isCartSummaryOpen = !$scope.isCartSummaryOpen;

        if ($scope.isCartSummaryOpen == true) {
            //GA4
            var items = [];
            for (var i = 0; i < $scope.Cart.CartItems.length; i++) {
                items.push({
                    //'item_id': $scope.Cart.CartItems[i].Product.ProductTypeId == 3 ? 'giftcard-' + $scope.Cart.CartItems[i].Product.PriceOriginal : ($scope.Cart.CartItems[i].Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + $scope.Cart.CartItems[i].Product.GA_ProductId.toString(),
                    'item_id': ($scope.Cart.CartItems[i].Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + $scope.Cart.CartItems[i].Product.GA_ProductId.toString(),
                    'item_name': $scope.Cart.CartItems[i].Product.Name.toLowerCase(),
                    'discount': $scope.Cart.CartItems[i].Product.Partnumber != null && $scope.Cart.CartItems[i].Product.Partnumber.PriceOriginal > 0 && $scope.Cart.CartItems[i].Product.Partnumber._price != null && $scope.Cart.CartItems[i].Product.Partnumber.PriceOriginal <= $scope.Cart.CartItems[i].Product.Partnumber._price ? $scope.Cart.CartItems[i].Product.PriceOriginal - $scope.Cart.CartItems[i].Product.Partnumber._price : 0,
                    'index': 1,
                    'item_brand': ($scope.Cart.CartItems[i].Product.BrandName != undefined ? $scope.Cart.CartItems[i].Product.BrandName : window.divisionFullName).toLowerCase(),
                    'item_category': $scope.Cart.CartItems[i].Product.PageCategories != undefined && $scope.Cart.CartItems[i].Product.PageCategories.length > 0 ? $scope.Cart.CartItems[i].Product.PageCategories[0].GA_label.toLowerCase() : 'n/a',
                    'item_category2': $scope.Cart.CartItems[i].Product.PageCategories != undefined && $scope.Cart.CartItems[i].Product.PageCategories.length > 1 ? $scope.Cart.CartItems[i].Product.PageCategories[1].GA_label.toLowerCase() : 'n/a',
                    'item_category3': $scope.Cart.CartItems[i].Product.PageCategories != undefined && $scope.Cart.CartItems[i].Product.PageCategories.length > 2 ? $scope.Cart.CartItems[i].Product.PageCategories[2].GA_label.toLowerCase() : 'n/a',
                    /*'item_list_name': $scope.Cart.CartItems[i].Product.GA_Category,*/
                    'item_variant': $scope.Cart.CartItems[i].Product.Partnumber != null ? ($scope.Cart.CartItems[i].Product.Partnumber.Size + ($scope.Cart.CartItems[i].Product.Partnumber.Color != undefined && $scope.Cart.CartItems[i].Product.Partnumber.Color.length > 0 ? ' ' + $scope.Cart.CartItems[i].Product.Partnumber.Color : '')).toLowerCase() : '',
                    'price': $scope.Cart.CartItems[i].Product.Partnumber.PriceOriginal,
                    'quantity': $scope.Cart.CartItems[i].Quantity
                });
            }
            trackEventGlobalAndLocalGA4({
                'ga4_name': 'view_cart',
                'ga4_currency': window.currencyCode,
                'ga4_value': $scope.Cart.TotalIncludingShippingCosts,
                'ga4_items': items
            });
        }
    }

    $scope.$on('cartUpdated', function () {
        $scope.isCartSummaryOpen = false;
        $scope.getCartSummary();
    });

    $scope.parseHtml = function (html) {
        return $sce.trustAsHtml(html);
    };

    $scope.$watch(function () { return $scope.isCartSummaryOpen && $scope.Cart.CartItems != null && $scope.Cart.CartItems.length > 0 }, function () {
        //A360: set focus to button and set tab index to -1 for all other items outside modal window
        if ($scope.isCartSummaryOpen && $scope.Cart.CartItems.length > 0) {
            setTimeout(
                function () {
                    document.getElementById('cartCloseButton').focus();
                    openDialog($('.summary-popup')[0]);
                }, 10);

            //A360 if escape button pressed and cart summary is open => close it.
            $("body").on("keydown", function (e) {
                if (e.key === "Escape") { // escape key maps to keycode `27`
                    $scope.isCartSummaryOpen = false;
                    $scope.$apply();
                }
            });
        } else if ($scope.Cart != undefined && $scope.Cart.CartItems != undefined) {
            setTimeout(
                function () {
                    closeDialog();
                    document.getElementById('cart-summary-container2').focus();
                }, 10);

            //A360 if escape button pressed and cart summary is open => close it.
            $("body").off("keydown");
        }
    });
}]);

angular.element(document).ready(function () {
    try {
        var appID = document.getElementById('app-cart');
        angular.bootstrap(appID, ['app-cart']);
    } catch (e) {
        //do nothing
    }
});